import React, { Component } from 'react'
import { connect } from 'react-redux'
import {Translate} from '../../../../../utils'
import {testActions} from '../../../../../actions'
import {testsConstants} from '../../../../../constants'
import {InputForm,BtnClick} from '../../../../_Common'
class SelectTime extends Component{
    constructor(props){
        super(props)
        this.state={
            testDate:"",
            testTime:""
        }
        this.HandleChange=this.HandleChange.bind(this)
        this.handleNext=this.handleNext.bind(this)
    }
    HandleChange(e){
        const {name,value}=e.target 
        this.setState({
            [name]:value
        })
    }
    handleNext(){
        if(this.state.testDate && this.state.testTime){
            let dateTest=new Date(this.state.testDate+" "+this.state.testTime)
            this.props.StoreStep(dateTest,testsConstants.SET_TIME_TEST)
        } 
    }
    render(){
        return(
            <div className="width-46per leftM-auto righttM-auto">
                    <span className="linhgth">{Translate('test','slDtTim')}</span>
                    <div className="dis-flex topM-8">
                        <InputForm
                            className="rightM-8"
                            name="testDate"
                            type="date"
                            onChange={this.HandleChange}
                            value={this.state.testDate}
                        />
                        <InputForm
                            className=""
                            name="testTime"
                            type="time"
                            onChange={this.HandleChange}
                            value={this.state.testTime}
                        />
                    </div>
                    <div className="dis-flex content-center topM-22">
                        <BtnClick
                            onClick={this.handleNext}
                            TxtBtn={Translate('test','nextstep')}
                            Color="bdg-onrg clr-white leftM-8"
                        />
                    </div>
                </div>
        )
    }
}
function mapState(state){
    return {}
}
const Actions={
    StoreStep:testActions.StoreStep
}
const ConnectedClass=connect(mapState,Actions)(SelectTime)
export {ConnectedClass as SelectTime}